import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { couriersApi } from "../api/couriers";

const QK = "courier-requests";

export function useCourierRequests(params?: Record<string, string>) {
  return useQuery({
    queryKey: [QK, params],
    queryFn: () => couriersApi.list(params),
    staleTime: 0,
  });
}

export function useCreateCourierRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: couriersApi.create,
    onSuccess: () => qc.invalidateQueries({ queryKey: [QK] }),
  });
}

export function useUpdateCourierRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof couriersApi.update>[1] }) =>
      couriersApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: [QK] }),
  });
}

export function useDeleteCourierRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: couriersApi.delete,
    onSuccess: () => qc.invalidateQueries({ queryKey: [QK] }),
  });
}

export function useOrderCourierRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: Parameters<typeof couriersApi.order>[1];
    }) => couriersApi.order(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: [QK] }),
  });
}

export function useRejectCourierRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data?: { notes?: string } }) =>
      couriersApi.reject(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: [QK] }),
  });
}

export function useReopenCourierRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: couriersApi.reopen,
    onSuccess: () => qc.invalidateQueries({ queryKey: [QK] }),
  });
}

export function useMarkReceivedCourierRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: couriersApi.markReceived,
    onSuccess: () => qc.invalidateQueries({ queryKey: [QK] }),
  });
}

export function useCancelCourierRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: couriersApi.cancel,
    onSuccess: () => qc.invalidateQueries({ queryKey: [QK] }),
  });
}

export function useCouriersPendingCount(enabled = true) {
  return useQuery({
    queryKey: ["couriers-pending-count"],
    queryFn: couriersApi.pendingCount,
    enabled,
    staleTime: 30_000,
  });
}
